"use strict";
exports.__esModule = true;
exports._getBeacons = exports.getApi = exports.setPageContext = exports.trackExitLink = exports.trackEventLater = exports.trackEvent = exports.trackPage = void 0;
var types_1 = require("../types");
function push(entry) {
    if (!window[types_1.WINDOW_KEY]) {
        window[types_1.WINDOW_KEY] = [];
    }
    return window[types_1.WINDOW_KEY].push(entry);
}
function getContextConfig(key, value) {
    var _a;
    if (typeof key === 'object') {
        return key;
    }
    return _a = {}, _a[key] = value, _a;
}
exports["default"] = {
    trackPage: trackPage,
    trackEvent: trackEvent,
    trackEventLater: trackEventLater,
    trackExitLink: trackExitLink,
    setPageContext: setPageContext,
    getApi: getApi
};
function trackPage(config) {
    return push([types_1.PAGE, config]);
}
exports.trackPage = trackPage;
function trackEvent(config) {
    return push([types_1.EVENT, config]);
}
exports.trackEvent = trackEvent;
function trackEventLater(config) {
    return push([types_1.EVENT_LATER, config]);
}
exports.trackEventLater = trackEventLater;
function trackExitLink(config) {
    return push([types_1.EXIT_LINK, config]);
}
exports.trackExitLink = trackExitLink;
function setPageContext(key, value) {
    return push([types_1.CONFIG, getContextConfig(key, value)]);
}
exports.setPageContext = setPageContext;
function getApi(callback) {
    return push([types_1.GET_API, callback]);
}
exports.getApi = getApi;
function _getBeacons() {
    return window[types_1.WINDOW_KEY];
}
exports._getBeacons = _getBeacons;
//# sourceMappingURL=index.js.map